<template>
    <form-wrapper class="intake-preventive" @submit="handleFormSubmission(data)">
        <intake-form-section>
            <form-row>
                <form-cell>
                    <text-field
                        :label="$t('forms.intake.preventive_care.fields.last_physical_exam.label')"
                        :placeholder="$t('forms.intake.preventive_care.fields.last_physical_exam.placeholder')"
                        :formData="data"
                        valuePath="lastPhysicalExam"
                        @change="change($event)"
                    ></text-field>
                </form-cell>
            </form-row>

            <form-row>
                <form-cell>
                    <tabs-field
                        :label="$t('forms.intake.preventive_care.fields.immunizations_up_to_date.label')"
                        :options="immunizationOptions"
                        :formData="data"
                        valuePath="immunizationsUpToDate"
                        size="small"
                        @change="change($event)"
                    ></tabs-field>
                </form-cell>
            </form-row>

            <form-row>
                <form-cell>
                    <text-field
                        :label="$t('forms.intake.preventive_care.fields.last_dental_visit.label')"
                        :formData="data"
                        valuePath="lastDentalVisit"
                        @change="change($event)"
                    ></text-field>
                </form-cell>
            </form-row>

            <form-row>
                <form-cell>
                    <text-field
                        :label="$t('forms.intake.preventive_care.fields.last_eye_exam.label')"
                        :formData="data"
                        valuePath="lastEyeExam"
                        @change="change($event)"
                    ></text-field>
                </form-cell>
            </form-row>

            <form-row>
                <form-cell>
                    <textarea-field
                        :label="$t('forms.intake.preventive_care.fields.recent_screenings.label')"
                        :formData="data"
                        valuePath="recentScreenings"
                        @change="change($event)"
                    ></textarea-field>
                </form-cell>
            </form-row>
        </intake-form-section>

        <template #footer>
            <common-buttons>
                <common-button
                    :label="$t('common.microcopy.back')"
                    type="secondary"
                    size="large"
                    :isSubmittable="false"
                    @click="goBack"
                ></common-button>
                <common-button
                    :label="$t('common.microcopy.next')"
                    type="primary"
                    size="large"
                    :isProcessing="isSending"
                ></common-button>
            </common-buttons>
        </template>
    </form-wrapper>
</template>

<script>
    import FormMixin from 'mixins/FormMixin'
    import IntakeFormSection from 'components/forms/intake/IntakeFormSection'

    const IMMUNIZATION_OPTIONS = ['yes', 'no', 'unknown']

    export default {
        mixins: [FormMixin],

        components: {
            IntakeFormSection,
        },

        props: {
            initialData: { type: Object, default: undefined },
        },

        data() {
            return {
                data: {
                    lastPhysicalExam: undefined,
                    immunizationsUpToDate: 'unknown',
                    lastDentalVisit: undefined,
                    lastEyeExam: undefined,
                    recentScreenings: undefined,
                    ...(this.initialData || {}),
                },
            }
        },

        computed: {
            immunizationOptions() {
                return IMMUNIZATION_OPTIONS.map((value) => ({
                    label: this.$t(`forms.intake.preventive_care.fields.immunizations_up_to_date.options.${value}`),
                    value,
                }))
            },
        },

        methods: {
            goBack() {
                this.emitEvent({ name: 'back', payload: this.data })
            },

            handleFormSubmission(data) {
                this.isSending = true
                this.emitSent(data)
                this.isSending = false
            },
        },
    }
</script>
